import { useSelector, useDispatch } from "react-redux";
import SelectSubject from "./SelectSubject";
import { useState, useEffect } from 'react'
import SetStudentWork from "./SetStudentWork";
import { getStudentActiveAndUpcomingSubjectsById } from "@app/services/student";
import { toast } from "react-toastify";
import { setSelectedSubject } from "@app/store/reducers/studentWork";
import { useDecodedParam } from "@app/hooks/useDecodedParam";
import { useNavigate } from "react-router-dom";

const SetWorkWrapper = () => {

	const studentWorkStore = useSelector((state: any) => state.studentWork);
	const id = useDecodedParam('id', '/students');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(false);
    const [studentSubjects, setStudentSubjects] = useState([]);
    
    useEffect(() => {
        if (!id) return;
        getStudentSubjects(id);
    },[id]);

	const getStudentSubjects = async (id: number) => {
        try {
            setLoading(true)
            const resp = await getStudentActiveAndUpcomingSubjectsById(id)
            if (resp.success === true) {
                setLoading(false)
				if(Object.keys(studentWorkStore?.subject ?? {}).length > 0){
					let found = resp?.collections.find((subject) => {return subject.id == studentWorkStore?.subject?.id})
					if(found == undefined){
						dispatch(setSelectedSubject({}))
					}
				}

                if(resp?.collections.length > 0){
					let subjects = (resp?.collections.length == 1) ? resp?.collections : [{id: 0, name: 'Mix and Match'}].concat(resp?.collections);
                    setStudentSubjects(subjects);
				}else{
					dispatch(setSelectedSubject({}))
                    toast.error('Unable to load student subjects. Please try again.');
                    setTimeout(() => navigate('/students'), 2000);
				}
            } else {
				dispatch(setSelectedSubject({}))
                setLoading(false)
                toast.error('Unable to load student subjects. Please try again.');
                setTimeout(() => navigate('/students'), 2000);
            }
        } catch (error: any) {
			dispatch(setSelectedSubject({}))
            setLoading(false)
            toast.error('Unable to load student subjects. Please try again.');
            setTimeout(() => navigate('/students'), 2000);
        }
    };
	
	return (
		<section className="content">
            <div className="container-fluid">
				{  Object.keys(studentWorkStore?.subject ?? {}).length == 0 && (
					<SelectSubject 
						subjects={studentSubjects}
						isLoading={isLoading}
						studentId={id}
					/>
				)}
				{ Object.keys(studentWorkStore?.subject ?? {}).length > 0 && (
					<SetStudentWork studentId={id} />
				)}
			</div>
		</section>
	);
};

export default SetWorkWrapper;